import * as React from "react";
import { BlockGrid } from "kanopi-components/BlockGrid";

interface Props {
  columns: number;
  [props: string]: unknown; // This captures the rest of the props
}

export const CoverSectionsGrid = ({ columns = 2, ...props }: Props) => (
  <BlockGrid
    columns={[1, 1, 1, columns]}
    gridColumnGap={[null, null, null, "scale800"]}
    gridRowGap={["scale600", "scale600", "scale600", "scale800"]}
    justifyItems={undefined}
    {...props}
  />
);
